import { FOOTER_DATES_FORMAT } from '../../event-progress/constants';

const formatProgressTime = (
  isoTime: string | null | undefined,
  locale: string,
  timezone: string
): string | null => {
  if (!isoTime) {
    return null;
  }

  return new Date(isoTime).toLocaleTimeString(locale, {
    ...FOOTER_DATES_FORMAT,
    timeZone: timezone,
  });
};

export default formatProgressTime;
